export default __webpack_public_path__ + "static/media/ched.fe5ee064.png";